import styled from '@emotion/styled';

export const ContainerLayout = styled.div`
  height: 100%;
  &.hasInnerNav {
    padding: 0 30px 50px 0;
  }
`;
